const PI2 = Math.PI * 2;

export {
    PI2
}